import { useState, useEffect } from 'react';
import { useGetCustomersQuery } from "./customersApiSlice"
import Customer from "./Customer"
import { Link } from 'react-router-dom'
import useAuth from "../../hooks/useAuth"
import useLang from '../../hooks/useLang'
import useTranslate from '../../hooks/useTranslate'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'

// immport screen
import { LoadingScreen } from "./../../screens";

// import `ChakraProvider` component
import { Box, Grid, GridItem, Center, Stack, HStack, Spacer, Container, Alert, AlertIcon, Button, Text, useToast } from '@chakra-ui/react'
import { TableContainer, Table, Thead, Tbody, Tr, Th } from '@chakra-ui/react'

// import `ChakraProvider` icon
import { AddIcon } from '@chakra-ui/icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers } from "@fortawesome/free-solid-svg-icons"

const CustomersList = () => {
    useTitle('ORACLY: Customers List')

    const [loading, setLoading] = useState(true);

    const toastInfo = useToast({
        position: 'bottom-left',
        variant: 'left-accent',
    })

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    const { username, isEmployee, isManager, isAdmin } = useAuth()

    const { lang } = useLang()
    const { T } = useTranslate(lang)

    const {
        data: customers,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetCustomersQuery('customersList', {
        pollingInterval: 15000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let menuContent
    if (isManager || isAdmin) {
        menuContent = (
            <>
                <Link to="/dash/customers/new">
                    <Button
                        size='sm'
                        leftIcon={<AddIcon />}
                        colorScheme='teal'
                        variant='solid'>
                        <Text
                            color='white'
                            display={{ base: 'none', sm: 'flex' }}
                            fontSize={{ base: "18", sm: "18", md: "18", lg: "18", xl: "20" }}
                            fontWeight={600}
                        >
                            {T.common.Add}
                        </Text>
                    </Button>
                </Link>
            </>
        )
    }
    if (isEmployee) {
    }

    let content
    if (isLoading) {
        content = (
            <>
                <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                    <Stack spacing={3}>
                        <PulseLoader color={"#FFF"} />
                    </Stack>
                </Box>
            </>
        )
    }

    if (isError) {
        if (isManager || isAdmin) {
            toastInfo({ title: 'LOAD : ' + error?.data?.message, status: 'info' })
            content = (
                <>
                    <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                        <Stack spacing={3}>
                            <Alert status='error'>
                                <AlertIcon />
                                {error?.data?.message}
                            </Alert>
                        </Stack>
                    </Box>
                </>
            )
        } else {
            toastInfo({ title: 'LOAD : ' + error?.data?.message, status: 'info' })
            content = (
                <>
                    <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                        <Stack spacing={3}>
                            <Alert status='error'>
                                <AlertIcon />
                                {error?.data?.message}
                            </Alert>
                        </Stack>
                    </Box>
                </>
            )
        }
    }

    if (isSuccess) {
        const { ids, entities } = customers

        let filteredIds
        if (isEmployee || isManager || isAdmin) {
            filteredIds = [...ids]
        } else {
            filteredIds = ids.filter(customerId => entities[customerId].username === username)
        }

        const tableContent = ids?.length && filteredIds.map(customerId => <Customer key={customerId} customerId={customerId} />)

        content = (
            <>
                <Box borderRadius='xl' p={2} fontSize={20} fontWeight={400} color='black' border='10px' textAlign={['center']} borderColor='black' bg='white' w="100%">
                    <TableContainer>
                        <Table
                            variant='striped'
                            size='sm'
                        >
                            <Thead>
                                <Tr>
                                    <Th w='30px'></Th>
                                    <Th>{T.customers.CustomerName}</Th>
                                    <Th>{T.customers.CustomerType}</Th>
                                    <Th>{T.customers.CustomerGenre}</Th>
                                    <Th isNumeric>{T.customers.Action}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {tableContent}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            </>
        )
    }

    let body = (
        <>
            {!loading ? (
                <Center bg='#45413C' p='0' color='white' axis='both'>
                    <Grid w='95vw' maxW='1500' minH='100vh' gap={5} p='5' templateColumns='repeat(12, 1fr)'>
                        <GridItem color='black' colSpan={{ base: "12", sm: "12", md: "12", lg: "12", xl: "12" }}>
                            <HStack color='white'>
                                <Box p='2' color='262626' textAlign={['left']} >
                                    <Text fontSize={{ base: "20", sm: "20", md: "20", lg: "24", xl: "28" }} fontWeight={700}><FontAwesomeIcon icon={faUsers} /> {T.customers.CustomersList}</Text><br />
                                </Box>
                                <Spacer />
                                <Box p='2' color='262626' textAlign={['right']}>
                                    {menuContent}
                                </Box>
                            </HStack>
                            {content}
                        </GridItem>
                    </Grid>
                </Center>
            ) : (
                <LoadingScreen section='CUSTOMERS' />
            )}
        </>
    )

    return body
}
export default CustomersList